module.exports = __webpack_public_path__ + "static/media/Saami.fcadba2b.png";